import React, { Component } from 'react';

class AlertMessage extends Component
{
	constructor(props) {
		super(props);
		let left = 230;
		if(window.innerWidth <= 800) {
			left = 200;
		}
		if(props.type === "information") {
			this.state = {
				type: props.type,
				button1: "OKAY",
				button2: null,
				buttonColor: "#a8bd4c"
			}
		}
		else if(props.type === "confirmation") {
			this.state = {
				type: props.type,
				button1: "YES",
				button2: "NO",
				buttonColor: "#c56d6f"
			}
		}
		else if(props.type === "warning") {
			this.state = {
				type: props.type,
				button1: "CLOSE",
				button2: null,
				buttonColor: "#c56d6f"
			}
		}
		this.onResize = this.onResize.bind(this);
	}

	componentDidMount() {
		window.addEventListener("resize", this.onResize.bind(this));
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this));
	}

	onResize() {
		if(window.innerWidth > 800) {
			this.setState({
				width: window.innerWidth-230,
				left: 230
			});
		}
		else {
			this.setState({
				width: window.innerWidth-200,
				left: 200
			});
		}
	}

	render() {
		return(<div className="Alert-message">
			<div><div>
				<div className="AM-cell" id="AM-text" style={{"border-color": this.state.buttonColor}}>
					<div>{this.props.text}</div>
					<div className="AM-button">
						{this.state.button2 != null && <button className="gray" onClick={this.props.onClick}>{this.state.button2}</button>}
						{this.state.type === "information" && <button className="green-two" onClick={this.props.onClick}>{this.state.button1}</button>}
						{this.state.type === "confirmation" && <button onClick={this.props.onClick} className="red">{this.state.button1}</button>}
						{this.state.type === "warning" && <button onClick={this.props.onClick} className="red">{this.state.button1}</button>}
					</div>
				</div>
			</div></div>
		</div>);
	}
}

export default AlertMessage;
